module.exports = __webpack_public_path__ + "img/20190826132909360截图20190824150145065.c7533101.jpg";